import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { RadioButton, RadioButtonGroup, RadioButtonGroupLayout, TextButton, TextButtonPriority } from 'wix-ui-tpa/cssVars';
import { useTranslation } from '../../contexts/translation-context';
import { SignatureDrawer } from './signature-drawer';
import { SignatureUpload } from './signature-upload';
import styles from './signature.scss';
var ESignatureTab = /*#__PURE__*/function (ESignatureTab) {
  ESignatureTab["Draw"] = "draw";
  ESignatureTab["Upload"] = "upload";
  return ESignatureTab;
}(ESignatureTab || {});
export function Signature(props) {
  const {
    inputId,
    ariaDescribedBy,
    ariaLabelledBy,
    enableUpload,
    buttonText
  } = props;
  const {
    t
  } = useTranslation();
  const drawer = useRef(null);
  const [tab, setTab] = useState(ESignatureTab.Draw);
  const [signature, setSignature] = useState();
  const ClearButton = /*#__PURE__*/React.createElement(TextButton, {
    as: "button",
    onClick: handleClear,
    tabIndex: !signature ? -1 : undefined,
    priority: TextButtonPriority.secondary,
    className: classNames(styles.clear, {
      [styles.hidden]: !signature
    })
  }, t('field.signature.clear-button.label'));
  return /*#__PURE__*/React.createElement("div", {
    id: inputId,
    className: styles.root,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy
  }, enableUpload ? /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(RadioButtonGroup, {
    value: tab,
    name: "variant",
    onChange: handleTabChange,
    layout: RadioButtonGroupLayout.Horizontal
  }, /*#__PURE__*/React.createElement(RadioButton, {
    value: ESignatureTab.Draw,
    label: t('field.signature.tabs.draw')
  }), /*#__PURE__*/React.createElement(RadioButton, {
    value: ESignatureTab.Upload,
    label: t('field.signature.tabs.upload')
  })), ClearButton) : /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, !enableUpload && ClearButton), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: tab === ESignatureTab.Upload ? `url(${signature})` : undefined
    },
    className: classNames(styles.field, {
      [styles.draw]: tab === ESignatureTab.Draw,
      [styles.upload]: tab === ESignatureTab.Upload
    })
  }, tab === ESignatureTab.Draw && /*#__PURE__*/React.createElement(SignatureDrawer, {
    ref: drawer,
    onSign: handleSign,
    className: styles.drawer,
    options: {
      throttle: 0,
      dotSize: 2,
      minWidth: 1,
      maxWidth: 3,
      velocityFilterWeight: 0.2,
      backgroundColor: 'transparent'
    }
  }), tab === ESignatureTab.Upload && /*#__PURE__*/React.createElement(SignatureUpload, {
    value: signature,
    label: buttonText,
    onChange: setSignature
  })));
  function handleSign() {
    var _drawer$current;
    setSignature((_drawer$current = drawer.current) == null ? void 0 : _drawer$current.toDataURL());
  }
  function handleTabChange(value) {
    setSignature(undefined);
    setTab(value);
  }
  function handleClear() {
    var _drawer$current2;
    setSignature(undefined);
    (_drawer$current2 = drawer.current) == null || _drawer$current2.clear();
  }
}
//# sourceMappingURL=signature.js.map